import React from "react";
import '../Styles/CategoryBanner.css';

const CategoryBannerForum= () => {   

    return (
        <div>
            <container id="forum-banner">
                Forum
            </container> 
        </div>
    
    )
}

export default CategoryBannerForum;
